import React from "react";
import ErrorBanner from "../../components/Error/ErrorBanner/ErrorBanner";

const Error = () => {
  return (
    <div>
      <ErrorBanner />
    </div>
  );
};

export default Error;
